module.exports = __webpack_public_path__ + "static/media/trc_logo.87092400.png";